import BaseScreen from './_base';

export default function SearchScreen() {
  return <BaseScreen title="Search" description="Global search across datasets." />;
}
